import { BootstrapAlertComponent, EAlertType } from './../../components/bootstrap-alert/bootstrap-alert.component';
import { ForgotPassword } from './../../core/models/forgotPassword.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/acceso/auth.service';
import { MessageDialog } from '../../components/message-dialog/messageDialog';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  providers: [AuthService]
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  loading: boolean;
  actualizado: boolean;

  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);


  constructor(private _authService: AuthService,
    private _messageDialog: MessageDialog) {}

  ngOnInit() {}

  onSubmit() {
    const forgotPassword: ForgotPassword = {
      Email: this.email
    };

    this.loading= true;
    this._authService.forgotPassword(forgotPassword).subscribe(
      res => {
        this.loading = false;
        this._messageDialog.ShowMessage( 'Se ha enviado un correo al email indicado.', '');
      },
      err => {
        this.loading = false;
        this._messageDialog.ShowAlert( 'No se ha podido enviar el correo.', 'Error');
        console.error(err);
      }
    );
  }
}
